import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import styledComponents from 'styled-components'
import { getFirestore, onSnapshot, orderBy, limit, collection, query, doc, where, getDoc, getDocs, setDoc } from "firebase/firestore";
import { auth, provider, storage, db1, analytics } from '../firebase'


export default function Details() {

  const { id } = useParams();
  const [movie, setMovie] = useState();

  useEffect(() => {


    const q = doc(db1, "movies", id)

    getDoc(q)
      // .then((doc) => {
      //   if (doc.exists) {
      //     setMovie(doc.data())
      //   } else {

      //   }

      // })

      onSnapshot(q,(doc)=>{
        setMovie(doc.data())
      })

  })

  return (
    <Cointainer>

{movie && <>
      <Background>
        <img src={movie.backgroundImg} />
      </Background>

      <ImageTitle>
        <img src={movie.titleImg} />
      </ImageTitle>
      <Controls>
        <PlayButton>
          <img src='/images/play-icon-black.png' />
          <span>PLAY</span>
        </PlayButton>
        <TrailerButton>
          <img src='/images/play-icon-white.png' />
          <span>Trailer</span>
        </TrailerButton>
        <AddButton>
          <span>+</span>
        </AddButton>
        <WatchButton>
          <img src='/images/group-icon.png' />
        </WatchButton>

      </Controls>
      <SubTittle>{movie.subtitle}</SubTittle>
      <Description>{movie.description}</Description>
  </>
}
      </Cointainer>
  )
}



const Cointainer = styledComponents.div`
min-height: calc(100vh - 70px);
padding: 0 calc(3.5vw + 5px);
position: relative;
overflow-x: hidden;
`
const Background = styledComponents.div`
position:fixed;
left:0;
right:0;
top:0;
bottom:0;
z-index:-1;
opacity:0.8;
img{
  width:100%;
  height:100%;
  object-fit:cover;
}

`

const ImageTitle = styledComponents.div`
height:30vh;
width:35vw;
min-height:170px;
min-width:200px;

 img{
  width:100%;
  height:100%;
  object-fit:contain;
 }


`


const Controls = styledComponents.div`
display:flex;
align-items:center;

`
const PlayButton = styledComponents.button`
border-radius:4px;
font-size: 15px;
display: flex;
align-items:center;
height: 56px;
background: rgba(249,249,249);
border: none;
padding: 0px 24px;
margin-right:22px;
letter-spacing:1.8px;
cursor:pointer;
text-transform:uppercase;
&:hover{
  background: rgba(198,198,198);
}
`

const TrailerButton = styledComponents(PlayButton)`
opacity:1;
background: rgba(0,0,0,0.3);
border: 1px solid rgb(249,249,249);
color:rgb(249,249,249);
`

const AddButton = styledComponents.button`
width:44px;
height:44px;
display:flex;
align-items:center;
justify-content:center;
border-radius:50%;

border: 2px solid white;
background-color:rgba(0,0,0,.6);
cursor:pointer;
margin-right: 16px;
span{
  font-size:30px;
  color:white;
}
`
const WatchButton = styledComponents(AddButton)`
background:rgb(0,0,0);
`

const SubTittle = styledComponents.div`
color: rgba(249,249,249);
font-size:15px;
min-height:20px;
margin-top:26px;
`

const Description = styledComponents.div`
margin-top:16px;
font-size:20px;
color: rgba(249,249,249);
line-height:1.4;
`